import { Component, ElementRef, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { environment } from '@env/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/auth/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/services/loader.service';
import { Title } from '@angular/platform-browser';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SearchService } from 'src/services/search-service.service';

@Component({
  selector: 'changepsw',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [MessageService],
})
export class ChangePasswordComponent implements OnInit {
  public privacyDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  images: any = [];
  data: any = [];
  hours: any = [];
  geocodes: any[];
  point: any[];
  name: string;
  psw: string;
  user_id: number;
  timer: string;
  token: string;
  weather: string;
  weatherimg: string;
  todaydate: Date;
  status: string;
  msg: string;
  changePasswordForm!: FormGroup;
  currentUser: any;
  fieldPasswordType: boolean;
  fieldConfirmPasswordType: boolean;
  fieldTempPasswordType: boolean;
  confirmMessage: string;
  confirmMessageSummary: string;
  displayCustom: boolean;
  activeIndex: any;
  fname: string;
  currentUrl: any;
  listItem: any = [];
  bannerImage: any;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  constructor(
    public productService: ProductService,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private loaderService: LoaderService,
    private titleService: Title,
    private messageService: MessageService,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private searchService: SearchService
  ) {
    this.createResetForm();
  }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    const currentRoute = this.route.routeConfig?.path?.split('/')[0] ?? '';
    if (currentRoute) {
      this.getListType(currentRoute);
    } else {
      this.getListType('reset-password');
    }

    this.route.paramMap.subscribe((paramMap) => {
      this.user_id = this.productService.getSessionUserId();
      const fname = this.productService.getSessionName();
      this.name = fname;
    });
  }

  getListType(selectedCat: any) {
    this.searchService.getListType(selectedCat).subscribe((data) => {
      const refListItem = data;
      this.listItem = [];
      this.listItem.push(refListItem);
      if (this.listItem[0].bannerImage) {
        this.bannerImage = this.listItem[0].bannerImage;
      } else {
        this.bannerImage = '../../../assets/images/NoImage.jpg';
      }
      this.images.push(this.bannerImage);
      this.titleService.setTitle(this.listItem[0].bannerTitle + ' ' + '| The Seychelles Islands');
    });
  }

  togglePasswordType() {
    this.fieldPasswordType = !this.fieldPasswordType;
  }
  toggleConfirmPasswordType() {
    this.fieldConfirmPasswordType = !this.fieldConfirmPasswordType;
  }
  toggleTempPasswordType() {
    this.fieldTempPasswordType = !this.fieldTempPasswordType;
  }

  onReject() {
    this.messageService.clear('c');
    this.authenticationService.logout().subscribe();
    //   setTimeout(() => {
    this.messageService.add({
      key: 'logout',
      severity: 'success',
      summary: this.translate.instant('Success'),
      detail: this.translate.instant('LogOut-Success'),
    });
    this.router.navigate(['/home']);
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  submit() {
    if (this.user_id != null && this.name != null) {
      // tslint:disable-next-line: max-line-length
      this.productService.changePassword(this.changePasswordForm.value, this.user_id, this.name).subscribe(
        (res: any) => {
          this.confirmMessage = this.translate.instant('Change-Password-Success');
          this.confirmMessageSummary = this.translate.instant('Please-Login-ChangePWD-Summary');
          this.messageService.add({
            key: 'c',
            sticky: true,
            severity: 'success',
            summary: this.confirmMessage,
            detail: this.confirmMessageSummary,
          });
          this.changePasswordForm.reset();
        },
        (err) => {
          if (err.status === 400) {
            this.messageService.add({
              key: 'logout',
              severity: 'error',
              summary: 'Error',
              detail: err.error.message,
            });
          } else {
            this.messageService.add({
              key: 'logout',
              severity: 'error',
              summary: 'Error',
              detail: err.error.message,
            });
          }
        }
      );
    } else {
      this.messageService.add({
        key: 'logout',
        severity: 'error',
        summary: this.translate.instant('Error'),
        detail: this.translate.instant('WrongWindow'),
      });
    }
  }

  private createResetForm() {
    this.changePasswordForm = this.formBuilder.group({
      password: new FormControl(null, Validators.required),
      confirmPassword: new FormControl(null, Validators.required),
    });
  }
}
